// extracted by mini-css-extract-plugin
export default {"container":"card_container__9S59B","card":"card_card__oX4Ev","buttons":"card_buttons__zBOe-","small":"card_small__oX1v1","large":"card_large__N3Ueh"};